<template>
  <a-modal width="70%" :visible="open" @cancel="onClose" :maskClosable="false">
    <a-divider orientation="left">
      <b>商家报价</b>
    </a-divider>
    <a-spin :spinning="detailLoading">
      <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form">
        <a-form-model-item label="商品名称">
          <span>{{ platformGoods.goodsName }}</span>
        </a-form-model-item>
        <a-form-model-item label="平台商品分类">
          <span>{{ (platformGoods.categoryNameList || []).join(' / ') }}</span>
        </a-form-model-item>
        <a-form-model-item label="本店商品分类">
          <a-tree-select
            v-model="form.merchantCategoryId"
            style="width: 100%"
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
            :tree-data="cateOptions"
            :replaceFields="{ children: 'children', title: 'categoryName', key: 'id', value: 'id' }"
            placeholder="请选择本店商品分类"
            tree-default-expand-all
            allow-clear>
          </a-tree-select>
        </a-form-model-item>
        <a-form-model-item label="本店运费模板">
          <a-select v-model="form.expressId" placeholder="请选择本店运费模板" allow-clear option-filter-prop="children" show-search>
            <a-select-option v-for="item in templateList" :key="item.id" :value="item.id">{{ item.name }}</a-select-option>
          </a-select>
        </a-form-model-item>

        <a-divider orientation="left">
          <span style="font-size: 13px">本店规格值（平台只定义规格名，规格值由本店填写）</span>
        </a-divider>
        <a-alert v-if="specRows.length === 0" type="info" show-icon style="margin-bottom: 12px">
          <template slot="message">
            平台商品未定义规格，本店按整件商品报价即可。
          </template>
        </a-alert>
        <template v-else>
          <a-alert type="info" show-icon style="margin-bottom: 12px">
            <template slot="message">
              可从平台候选值中选择，也可直接输入本店自有的规格值（输入后回车确认）。不同规格值组合将自动生成报价行。
            </template>
          </a-alert>
          <a-form-model-item v-for="spec in specRows" :key="spec.specName" :label="spec.specName">
            <a-select
              v-model="spec.selected"
              mode="tags"
              style="width: 100%"
              placeholder="请选择或输入本店规格值"
              @change="buildSkuList">
              <a-select-option v-for="option in spec.options" :key="option" :value="option">{{ option }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </template>

        <a-divider orientation="left">
          <span style="font-size: 13px">本店售价 / 库存 / 重量</span>
        </a-divider>
        <a-alert type="warning" show-icon style="margin-bottom: 12px">
          <template slot="message">
            售价与库存必须全部填写且售价大于0，审核通过后买家才能在线上直接购买；不填则不提交报价。
          </template>
        </a-alert>
        <a-table
          :data-source="form.skuList"
          :columns="skuColumns"
          rowKey="skuName"
          :pagination="false"
          size="small"
          bordered>
          <span slot="skuName" slot-scope="text, record">
            {{ record.skuName || '整件商品' }}
          </span>
          <span slot="price" slot-scope="text, record">
            <a-input-number v-model="record.price" :min="0" :precision="2" placeholder="本店售价" style="width: 100%"/>
          </span>
          <span slot="stock" slot-scope="text, record">
            <a-input-number v-model="record.stock" :min="0" :precision="0" placeholder="本店库存" style="width: 100%"/>
          </span>
          <span slot="weight" slot-scope="text, record">
            <a-input-number v-model="record.weight" :min="0" :precision="0" placeholder="重量(g)" style="width: 100%"/>
          </span>
        </a-table>
      </a-form-model>
    </a-spin>
    <div class="bottom-control">
      <a-space>
        <a-button type="primary" :loading="submitLoading" @click="submitForm">提交审核</a-button>
        <a-button type="dashed" @click="onClose">取消</a-button>
      </a-space>
    </div>
  </a-modal>
</template>

<script>
import { getPlatformPool, savePlatformQuote } from '@/api/goods/goods'
import { merchantCategoryTree } from '@/api/goods/category'
import { selectShippingTemplate } from '@/api/goods/shippingTemplate'

export default {
  name: 'QuoteForm',
  data () {
    return {
      labelCol: { span: 5 },
      wrapperCol: { span: 17 },
      submitLoading: false,
      detailLoading: false,
      open: false,
      platformGoods: {},
      cateOptions: [],
      templateList: [],
      specRows: [],
      form: {
        goodsId: undefined,
        merchantCategoryId: undefined,
        expressId: undefined,
        skuList: []
      },
      skuColumns: [
        { title: '规格组合', dataIndex: 'skuName', width: '34%', scopedSlots: { customRender: 'skuName' } },
        { title: '本店售价', dataIndex: 'price', width: '24%', scopedSlots: { customRender: 'price' } },
        { title: '本店库存', dataIndex: 'stock', width: '24%', scopedSlots: { customRender: 'stock' } },
        { title: '重量(g)', dataIndex: 'weight', width: '18%', scopedSlots: { customRender: 'weight' } }
      ]
    }
  },
  created () {
    merchantCategoryTree({}).then(response => {
      this.cateOptions = response.data
    })
    selectShippingTemplate({ pageNum: 1, pageSize: 500 }).then(response => {
      this.templateList = response.data.records || []
    })
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    reset () {
      this.platformGoods = {}
      this.specRows = []
      this.form = {
        goodsId: undefined,
        merchantCategoryId: undefined,
        expressId: undefined,
        skuList: []
      }
    },
    handleOpen (goodsId) {
      this.reset()
      this.open = true
      this.detailLoading = true
      this.form.goodsId = goodsId
      getPlatformPool({ id: goodsId }).then(response => {
        const detail = response.data || {}
        this.platformGoods = detail.platformGoods || {}
        this.buildSpecRows()
        this.fillOwnQuote(detail.quoteList || [])
      }).finally(() => {
        this.detailLoading = false
      })
    },
    /** 以平台规格名为骨架，候选值来自平台，商家可自增 */
    buildSpecRows () {
      const platformSpecList = this.platformGoods.specList || []
      this.specRows = platformSpecList.map(spec => {
        const options = (spec.specValueList || []).map(value => value.specValueName).filter(name => !!name)
        return { specName: spec.specName, options: options, selected: [] }
      })
      this.buildSkuList()
    },
    /** 回填本店已有报价：skuName 按规格顺序以 / 拼接 */
    fillOwnQuote (quoteList) {
      if (!quoteList || quoteList.length === 0) {
        return
      }
      quoteList.forEach(quote => {
        const names = (quote.skuName || '').split('/')
        this.specRows.forEach((spec, index) => {
          const name = names[index]
          if (!name) {
            return
          }
          if (!spec.options.includes(name)) {
            spec.options.push(name)
          }
          if (!spec.selected.includes(name)) {
            spec.selected.push(name)
          }
        })
      })
      this.buildSkuList()
      const oldMap = {}
      quoteList.forEach(quote => {
        oldMap[quote.skuName || ''] = quote
      })
      this.form.skuList.forEach(row => {
        const old = oldMap[row.skuName]
        if (old) {
          row.price = old.price
          row.stock = old.stock
          row.weight = old.weight
        }
      })
    },
    /** 按已选规格值生成笛卡尔积报价行，并保留已填的价格库存 */
    buildSkuList () {
      const oldMap = {}
      this.form.skuList.forEach(row => {
        oldMap[row.skuName || ''] = row
      })
      const activeSpecRows = this.specRows.filter(spec => spec.selected.length > 0)
      if (activeSpecRows.length === 0) {
        const old = oldMap[''] || {}
        this.form.skuList = [{ skuName: '', specValueIds: '', price: old.price, stock: old.stock, weight: old.weight }]
        return
      }
      // 规格值下标从1开始，按规格顺序与选中顺序排列，与后端一致
      let index = 1
      const indexMap = {}
      activeSpecRows.forEach(spec => {
        spec.selected.forEach(name => {
          indexMap[spec.specName + '|' + name] = index
          index++
        })
      })
      let combos = [[]]
      activeSpecRows.forEach(spec => {
        const next = []
        combos.forEach(combo => {
          spec.selected.forEach(name => {
            next.push(combo.concat([name]))
          })
        })
        combos = next
      })
      this.form.skuList = combos.map(combo => {
        const skuName = combo.join('/')
        const old = oldMap[skuName] || {}
        const idList = activeSpecRows.map((spec, i) => indexMap[spec.specName + '|' + combo[i]])
        return { skuName: skuName, specValueIds: idList.join(':'), price: old.price, stock: old.stock, weight: old.weight }
      })
    },
    submitForm () {
      if (!this.form.expressId) {
        this.$message.warning('请选择本店运费模板')
        return
      }
      if (this.form.skuList.length === 0) {
        this.$message.warning('请先填写本店规格值')
        return
      }
      if (this.specRows.length > 0 && this.form.skuList.length === 1 && !this.form.skuList[0].skuName) {
        this.$message.warning('该商品有规格，请至少为一个规格填写本店规格值')
        return
      }
      const invalid = this.form.skuList.filter(row => !row.price || row.price <= 0)
      if (invalid.length > 0) {
        this.$message.warning('请填写全部规格组合的售价，且售价需大于0')
        return
      }
      const specList = this.specRows
        .filter(spec => spec.selected.length > 0)
        .map(spec => ({
          specName: spec.specName,
          specValueList: spec.selected.map(name => ({ specValueName: name }))
        }))
      const skuList = this.form.skuList.map(row => ({
        skuName: row.skuName,
        specValueIds: row.specValueIds,
        price: row.price,
        stock: row.stock === null || row.stock === undefined ? 0 : row.stock,
        weight: row.weight === null || row.weight === undefined ? 0 : row.weight,
        picture: this.platformGoods.picture
      }))
      const params = {
        goodsId: this.form.goodsId,
        merchantCategoryId: this.form.merchantCategoryId,
        expressId: this.form.expressId,
        specList: specList,
        skuList: skuList
      }
      this.submitLoading = true
      savePlatformQuote(params).then(() => {
        this.$message.success('提交成功，请等待平台审核', 3)
        this.open = false
        this.$emit('ok')
      }).finally(() => {
        this.submitLoading = false
      })
    }
  }
}
</script>

<style lang="less" scoped>
.bottom-control {
  margin-top: 16px;
  text-align: center;
}
</style>
